import "../css/template.css";
import "../css/site.less";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "flag-icon-css/less/flag-icon.less";